/**
 * Subdomain Detector Utility
 * Detects if the app is accessed via a wildcard subdomain (*.users.godreamx.com)
 * and extracts the organization name from the subdomain
 */

/**
 * Checks if the current hostname is a user subdomain
 * @returns {Object} { isUserSubdomain: boolean, orgName: string|null }
 */
export function detectSubdomain() {
  const hostname = window.location.hostname

  console.log('🔍 Detecting subdomain for hostname:', hostname)

  // Pattern: {orgName}.users.godreamx.com
  const userSubdomainPattern = /^([a-z0-9-]+)\.users\.godreamx\.com$/i

  const match = hostname.match(userSubdomainPattern)

  if (match) {
    const orgName = match[1]
    console.log('✅ User subdomain detected! Organization:', orgName)

    return {
      isUserSubdomain: true,
      orgName: orgName,
      mode: 'viewer' // Template viewer mode
    }
  }

  // Check if localhost with port (for local development testing)
  if (hostname.includes('localhost') || hostname === '127.0.0.1') {
    // Allow testing subdomain mode via query parameter: ?preview=acme
    const urlParams = new URLSearchParams(window.location.search)
    const previewOrg = urlParams.get('preview')

    if (previewOrg) {
      console.log('🧪 Local preview mode for organization:', previewOrg)
      return {
        isUserSubdomain: true,
        orgName: previewOrg,
        mode: 'viewer'
      }
    }
  }

  console.log('📝 Editor mode - no user subdomain detected')

  return {
    isUserSubdomain: false,
    orgName: null,
    mode: 'editor' // Template editor mode
  }
}

/**
 * Get the base domain for API calls
 * @returns {string} Base domain
 */
export function getBaseDomain() {
  const hostname = window.location.hostname

  // If on user subdomain, strip it to get base domain
  if (hostname.match(/\.users\.godreamx\.com$/i)) {
    return 'godreamx.com'
  }

  // For localhost
  if (hostname.includes('localhost') || hostname === '127.0.0.1') {
    return 'localhost'
  }

  return hostname
}

/**
 * Check if we should show the template viewer
 * @returns {boolean}
 */
export function shouldShowViewer() {
  const { isUserSubdomain } = detectSubdomain()
  return isUserSubdomain
}
